import { render, staticRenderFns } from "./userItem.vue?vue&type=template&id=254db9bf&"
import script from "./userItem.vue?vue&type=script&lang=ts&"
export * from "./userItem.vue?vue&type=script&lang=ts&"
import style0 from "./userItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports